import React, { lazy, Suspense } from "react";
import HeroSection from "../HeroSection/HeroSection";
import DetailsNavbar from "../DetailsNavbar/DetailsNavbar";
const PaymentFeature = lazy(() => import("../../PaymentFeature/PaymentFeature"));
const Footer = lazy(() => import("../Footer/Footer"));
const ManageDebt = lazy(() => import("../ManageDebt/ManageDebt"));
const Certificates = lazy(() => import("../Certificates/Certificates"))

const Home = () => {
  return (
    <>
      <DetailsNavbar/>
      <HeroSection />

      <Suspense fallback={null}>
        <Certificates />
        </Suspense>
        <Suspense fallback={null}>
        <PaymentFeature />
        </Suspense>
        <Suspense fallback={null}>
        <ManageDebt/>
        </Suspense>
        <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </>
  );
};

export default Home;
